/** Sprachen der Oberfläche; Deutsch ist Standard (auch für Clients ohne Angabe). */
export const LANGS = ['de', 'en'];
/** Zahlen und Daten: Englisch als en-GB (24-h-Zeit, Tag vor Monat, km) – siehe client/src/i18n/index.ts. */
export const LOCALE = { de: 'de-DE', en: 'en-GB' };
//# sourceMappingURL=lang.js.map